import React from 'react'
import './style.css'
//import { navigate } from 'hookrouter';
//import { Logout } from '../../config/api';
import LogoAtlas from "../../assets/atlasBHRILogoMono.svg";
import LogoITV from "../../assets/ITV_gs_neg_CMYK.png";
//import ExitIcon from "../../assets/Exit.svg";

const Navbar = (props) => {

 /*   const logout = async () => {

        await props.clearJanelas()

        sessionStorage.removeItem('logado')
        navigate("/login")
        await Logout()
    }
*/
    return (
        <div className="divStyle">
            <div className="divAtlasContainer">
                {/* <div style={{ height: 35, width: 35, backgroundColor: "#FFF", borderRadius: 4, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <label style={{ fontFamily: "Caecilia", fontSize: 30, color: "#0b7e7a", fontWeight: "bold", marginBottom: -5 }}>A</label>
                </div> */}
                <img
                    src={LogoAtlas}
                    width={45}
                    alt="Atlas Geoquímico da Bacia Hidrográfica do Rio Itacaiúnas"
                />
                <label className="divAtlasName">ATLAS GEOQUÍMICO DA BÁCIA HIDROGRAFICA DO RIO ITACAIÚNAS</label>
                {/*{ <div style={{ display: "flex", flexDirection: "row" }}>
                    <img
                        src={ExitIcon}
                        height={16}
                        alt="Sair"
                    />
                    <div className="divLogout" onClick={() => logout()}>
                        <label className="textLogout">Sair</label>
                    </div>
                </div> }*/}
            </div>

            {/* {props.menus.length > 0 && props.menus.map((m, i) => (
                <label key={i} className={`textStyle ${m.isSelect ? 'textSelect' : ''} `} onClick={() => m.click()}> {m.label} </label>
            ))} */}

            <div style={{ flexDirection: "row", display: "flex" }}>
                <div className="divITVlogo">
                    <img src={LogoITV} alt="ITV logo"  />
                </div>
                {/* <div className="divDividerLogoAndExit" /> */}
                {/*<img
                    className="exitIcon"
                    onClick={() => logout()}
                    src={ExitIcon}
                    height={20}
                    alt="Sair"
                />*/}
            </div>
        </div>
    )
}

export default Navbar